import { Injectable } from '@angular/core';
import { Models } from '@ibexfusion/models';

import { RestProvider, RestService } from '../rest/rest.service';
import { RestfulService } from '../rest/restful';

@Injectable()
export class RoleHasPrivilegesService extends RestfulService<Models.RoleHasPrivilege> {

  constructor(private restService: RestService) {
    super(Models.RoleHasPrivilege);
    super.init();
  }

  public createProvider(): RestProvider {
    return this.restService.createProvider('role-has-privileges');
  }

}
